import z from 'zod'
import { accountingIntegrations, publicApiIntegrations } from '@omnea-app/packages/universal/integrations/globalIntegrations'

export const SupplierRemoteTypeSchema = z.enum([...accountingIntegrations, ...publicApiIntegrations])
export type SupplierRemoteType = z.infer<typeof SupplierRemoteTypeSchema>
